import { buildQueryString } from '@izimi/utils';

import type FetchService from '../FetchService';
import type { ApiComponentType } from '../types';
import type { ApiConfiguration, ApiVersion } from './types';

class PublicApi {
  constructor(private fetchService: FetchService) {}

  getVersion() {
    return this.fetchService.get<ApiVersion>('/public/version');
  }

  getConfiguration() {
    return this.fetchService.get<ApiConfiguration>('/public/configuration/citizen-mobile');
  }

  getWebConfiguration() {
    return this.fetchService.get<ApiConfiguration>('/public/configuration/citizen-web');
  }

  getNotaryConfiguration() {
    return this.fetchService.get<ApiConfiguration>('/public/configuration/notary-web');
  }

  getPortalConfiguration() {
    return this.fetchService.get<ApiConfiguration>('/public/configuration/citizen-portal');
  }

  getMailUnsubscribeInfo(token: string) {
    const query = buildQueryString({ token });
    return this.fetchService.get<ApiComponentType<'UnsubscriptionToken'>>(
      `/public/mail/unsubscribe/info${query}`,
    );
  }

  mailUnsubscribe(token: string) {
    return this.fetchService.post<void>(`/public/mail/unsubscribe`, { token });
  }
}

export default PublicApi;
